import React, { useEffect, useState } from "react";
import Link from "@mui/material/Link";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import {
  Book,
  AccountCircle
} from "@mui/icons-material";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import Report from "@mui/icons-material/Report";
import PrecisionManufacturing from '@mui/icons-material/PrecisionManufacturing';
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import CssBaseline from "@mui/material/CssBaseline";
import { guruUtils } from "./Utils";
import { errorColor } from "./Theme";

export default function GuruMenu({ menuWidth }) {
  let navigate = useNavigate();

  const accountClicked = (event) => {
    navigate("/account");
  };

  const automationsClicked = (event) => {
    navigate("/automations");
  };

  const docsClicked = (event) => {
    window.open("https://docs.getguru.ai/introduction", "_blank");
  };

  return (
    <>
      <CssBaseline />
      <Drawer
        variant={"permanent"}
        sx={{
          width: menuWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: menuWidth,
            boxSizing: "border-box",
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        <Toolbar>
          <Link href={"/"}>
            <img src={"./strange_loop.png"} height={"30"} alt={"Strange Loop Labs"} />
          </Link>
        </Toolbar>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            paddingX: 1,
          }}
        >
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={automationsClicked}>
                <ListItemIcon>
                  <PrecisionManufacturing className={"on-light"} />
                </ListItemIcon>
                <ListItemText primary={"Automations"} />
              </ListItemButton>
            </ListItem>
          </List>

          <List>
            <Divider />
            <ListItem disablePadding>
              <ListItemButton onClick={docsClicked}>
                <ListItemIcon>
                  <Book className={"on-light"} />
                </ListItemIcon>
                <ListItemText primary={"Docs"} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate("/account")}>
                <ListItemIcon>
                  <AccountCircle className={"on-light"} />
                </ListItemIcon>
                <ListItemText primary={"Account"} />
              </ListItemButton>
            </ListItem>
            {guruUtils.getTenantOverride() && (
              <ListItem disablePadding>
                <ListItemButton onClick={accountClicked}>
                  <ListItemIcon>
                    <Report sx={{ color: errorColor }} />
                  </ListItemIcon>
                  <ListItemText
                    secondary={guruUtils.getTenantOverride()}
                    sx={{ overflow: "hidden" }}
                  />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
}
